import React from 'react'
import {toast} from "react-toastify";
import Sidebar from "../../../../components/Sidebar";
import PageHeader from "../../../../components/PageHeader";
import EmailTypeApi from "../../../../services/ob-core/email-type";
import EmailTypeDataApi from "../../../../services/ob-core/email-type-data";

class EmailConfig extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 0,
            pageSize: 10,
            totalItem: null,
            itemSelected: {},
            showLoading: false,
            type: [],
            typeData: [],
            selectedType: null,
            emailContent: null,
            selectedTypeData: null,
        }
    }

    componentWillMount() {
        this.setState({showLoading: true}, () => {
            // this.getData()
            this.getListType()
        })
    }

    getListType = () => {
        EmailTypeApi.getAll(res => {
            if (res.success) {
                this.setState({type: res.data, showLoading: false})
            }
        })
    }

    selectType = (val) => {
        this.setState({selectedType: val, selectedTypeData: null}, () => {
            this.getTypeData();
            this.getTypeContent()
        })
    }

    selectTypeData = (val) => {
        let filter = this.state.typeData?.filter((item) => item.data == val)
        // console.log("check filter>>>>>", filter)
        this.setState({selectedTypeData: filter[0]}, () => {

        })
    }

    getTypeData = () => {
        let payload = {
            type: this.state.selectedType
        }
        EmailTypeDataApi.getListTypeData(payload, res => {
            if (res.success) {
                this.setState({typeData: res.data})
            }
        })
    }

    getTypeContent = () => {
        let payload = {
            type: this.state.selectedType
        }
        EmailTypeApi.getEmailTypeBody(payload, res => {
            if (res.success) {
                this.setState({emailContent: res.data})
            }
        })
    }

    onSave = () => {
        let payload = {
            body: this.state.content || this.state.emailContent.body,
            id: this.state.emailContent.id,
            subject: this.state.subject || this.state.emailContent.subject
        }
        EmailTypeApi.update(payload, res => {
            if (res.success) {
                toast.success("Cập nhật thành công")
            }
        })
    }

    render() {
        let {pageNumber, pageSize, totalItem} = this.state;
        return(
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="email-config" parentClass="config-system"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className='pt-3 mb-4'>
                                    <PageHeader routerEnable={true} title="Cấu hình Email"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-6 pl-0">
                                                <label className="label-item">Loại Email</label>
                                                <select className="form-control kt-input pd-4-input shadow-none"
                                                        defaultValue={0}
                                                        onChange={(val) => {
                                                            this.selectType(val.target.value)
                                                            // this.setState({
                                                            //     selectedType: val.target.value
                                                            // })
                                                        }}
                                                >
                                                    <option value={0} disabled>Chọn một loại Email</option>
                                                    {this.state.type?.map(item => (
                                                        <option value={item.type}>{item.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-6 pl-0 row">
                                                <label className="label-item">Label</label>
                                                <select className="form-control kt-input pd-4-input shadow-none"
                                                        defaultValue={0}
                                                        onChange={(val) => {
                                                            this.selectTypeData(val.target.value)
                                                            // this.setState({
                                                            //     selectedType: val.target.value
                                                            // })
                                                        }}
                                                >
                                                    <option value={0} disabled>Chọn một label</option>
                                                    {this.state.typeData?.map(item => (
                                                        <option value={item.data}>{item.data}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-6 pr-0">
                                                <label className="label-item">Giải thích label</label>
                                                <div className="align-items-center pl-2 d-flex" style={{height: 35, border: "1px solid #ced4da", borderRadius: ".25rem", backgroundColor: '#ced4da'}}>
                                                    <span>{this.state.selectedTypeData?.data} - {this.state.selectedTypeData?.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2 mb-2 pl-0 pr-0">
                                    <label className="label-item">Tiêu đề Email</label>
                                    <input type="text" className="form-control" maxLength={100} value={this.state.onEdit ? this.state.subject : this.state.emailContent?.subject}
                                           onChange={(val) => {
                                               this.setState({subject: val.target.value, onEdit: true})
                                    }}/>
                                </div>
                                <div className="table-wrapper">
                                    <label className="label-item">Nội dung Email</label>
                                    <textarea name="" id="" rows="10" className="form-control" value={this.state.onEdit ? this.state.content : this.state.emailContent?.body} maxLength={2000}
                                              onChange={(val)=>{
                                                    this.setState({content: val.target.value, onEdit: true})
                                    }}/>
                                </div>
                                <div
                                    className='mt-2 mb-3 col-xs-12 col-sm-12 col-md-6 align-text-bottom pl-0  button-filter-wp'>
                                    <div className="button-filter">
                                        <button
                                            type="button"
                                            className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                            onClick={() => {
                                                this.onSave()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default EmailConfig
